import React from "react";
import "./NodeDetailsModal.css";
import { MdEmail, MdLocationOn } from "react-icons/md";
import { FaFireAlt, FaRoad, FaWalking } from "react-icons/fa";

interface MetricData {
  target: number;
  value: number;
  unit: string;
  performance: number;
  gcr: number;
  goal_count: number;
  achieved_goals: number;
}

interface SummaryData {
  overall_performance: number;
  overall_gcr: number;
  overall_achieved_goals: number;
  overall_goal_count: number;
  metrics: Array<{
    steps: MetricData;
    distance: MetricData;
    caloriesburned: MetricData;
  }>;
}

interface NodeDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  data: any;
  userImages: Record<string, string>; 
}

const NodeDetailsModal: React.FC<NodeDetailsProps> = ({ isOpen, onClose, data,userImages  }) => {
  if (!isOpen || !data) return null;

  const {
    name,
    job_title,
    department,
    location,
    self_metrics,
    vertical_metrics,
  } = data;

  const self = self_metrics?.data?.[0] ?? data?.data?.[0]; 
  const selfDetails = self?.metrics?.[0];

  const team = data.children && data.children.length > 0 &&
  vertical_metrics && Array.isArray(vertical_metrics.data) && vertical_metrics.data.length > 0 
  ? vertical_metrics.data[0]
  : null;

const teamDetails = team && Array.isArray(team.metrics) && team.metrics.length > 0
  ? team.metrics[0]
  : null;

  const renderMetricCard = (
    label: string,
    value: string,
    performance: string,
    total: number,
    // tag: string,
    unit: string,
    colorClass: string,
    Icon: React.ElementType
  ) => (
    <div className={`NodeDetails-metric-card ${colorClass}`}>
      <div className="NodeDetails-metric-label">
        <Icon style={{ marginRight: "8px", verticalAlign: "middle" }} />
        {label}
      </div>
      <div className="metric-main">{value}</div>
      <div className="metric-sub">{unit}</div>
      <div className="progress-outer">
        <div className="NodeDetails-progress-inner" style={{ width: `${performance}%` }} />
      </div>
      <div className="metric-footer">{`${performance}% of ${total} ${unit}`}</div>
    </div>
  );  

  return (
    <div className="NodeDetails-modal-overlay" onClick={onClose}>
      <div className="NodeDetails-modal-container" onClick={(e) => e.stopPropagation()}>
        <button className="NodeDetails-modal-close" onClick={onClose}>×</button>

        <h2 className="NodeDetailEmployeeMetrics">Employee Metrics</h2>
        <div className="NodeDetailsuser-info">
         <div className="NodeDetailsuser-avatar">
          {userImages?.[data.user_uid] ? (
            <img
              src={`data:image/jpeg;base64,${userImages[data.user_uid]}`}
              alt="Profile"
              style={{
                width: "60px",
                height: "60px",
                borderRadius: "50%",
                objectFit: "cover",
              }}
            />
          ) : (
            <span>👤</span>
          )}
        </div>
          <div>
            <h3>{name}</h3>
            <p>{job_title}</p>
            <p>{department}</p>
{data.user_uid && (
  <div className="NodeDetailsContactRow">
    <MdEmail size={16} style={{ marginRight: "4px" }} />
    <span>{data.user_uid}</span>
  </div>
)}

{data.location && (
  <div className="NodeDetailsContactRow">
    <MdLocationOn size={16} style={{ marginRight: "4px" }} />
    <span>{data.location}</span>
  </div>
)}
          </div>
        </div>
        {/* Self Metrics */}
        {self && selfDetails && (
          <>
            <h4 className="NodeDetailsSelfMetrics">Self Metrics</h4>
            <div className="Modalmetrics-row">
  <div className="NodeDetails-goal-summary goal-box">
    <p>Goal Achieved</p>
    <h2 className="NodeDetailsGoalAchieved">{self?.overall_achieved_goals}/{self?.overall_goal_count}</h2>
    <div className="NodeDetailstag">Completed</div>
  </div>

  <div className="circular-gcr gcr-box">
    <p>Overall GCR</p>
    <div className="gcr-ring">
  <div className="gcr-ring-wrapper">
    <svg width="80" height="80">
      <circle
        className="bg"
        cx="40"
        cy="40"
        r="30"
      />
      <circle
        className="NodeDetails-progress"
        cx="40"
        cy="40"
        r="30"
        strokeDasharray={2 * Math.PI * 30}
        strokeDashoffset={(1 - (self?.overall_gcr ?? 0) / 100) * 2 * Math.PI * 30}
      />
    </svg>
    <div className="gcr-center-text">{`${self?.overall_gcr ?? 0}`}</div>
  </div>
  <span className="NodeDetailsunit">in %</span>
</div>
  </div>
</div>


<div className="performance-section Nodalperformance-box">
<div className="NodeOverPerformanceTextandPercentage">
  <p>Overall Performance</p>
  <div className="performance-text">{self?.overall_performance ?? 0}%</div>
  </div>
  <div className="OverallPerformance-progress-outer bordered-bar">
    <div className="NodeDetails-progress-inner" style={{ width: `${self?.overall_performance ?? 0}%` }} />
  </div>
</div>
<div className="NodeDetails-metric-cards-container">
  {renderMetricCard("Calories Burned", selfDetails.caloriesburned.value, selfDetails.caloriesburned.performance, selfDetails.caloriesburned.target, selfDetails.caloriesburned.unit, "red", FaFireAlt)}
  {renderMetricCard("Distance", selfDetails.distance.value, selfDetails.distance.performance, selfDetails.distance.target, selfDetails.distance.unit, "green", FaRoad)}
  {renderMetricCard("Steps", selfDetails.steps.value, selfDetails.steps.performance, selfDetails.steps.target, selfDetails.steps.unit, "blue", FaWalking)}
</div>
          </>
        )}

        {/* Team Metrics */}
        {team && teamDetails && (
          <>
            <h4 className="NodeDetailsSelfMetricsTeams">Team Metrics</h4>
            <div className="Modalmetrics-row">
            <div className="NodeDetails-goal-summary goal-box">
                <p>Goal Achieved</p>
                <h2 className="NodeDetailsGoalAchievedTeams">{team.overall_achieved_goals}/{team.overall_goal_count}</h2>
                <div className="NodeDetailstag">Completed</div>
              </div>
              
       <div className="circular-gcr gcr-box">
                <p>Overall GCR</p>
                <div className="gcr-ring">
  <div className="gcr-ring-wrapper">
    <svg width="80" height="80">
      <circle
        className="bg"
        cx="40"
        cy="40"
        r="30"
      />
      <circle
        className="NodeDetails-progress"
        cx="40"
        cy="40"
        r="30"
        strokeDasharray={2 * Math.PI * 30}
        strokeDashoffset={(1 - (team?.overall_gcr ?? 0) / 100) * 2 * Math.PI * 30}
      />
    </svg>
    <div className="gcr-center-text">{`${team?.overall_gcr ?? 0}`}</div>
  </div>
  <span className="NodeDetailsunit">in %</span>
</div>
              </div>
            </div>
            <div className="performance-section Nodalperformance-box">
              <div className="NodeOverPerformanceTextandPercentage">
  <p>Overall Performance</p>
  <div className="performance-text">{team?.overall_performance ?? 0}%</div>
  </div>
  <div className="OverallPerformance-progress-outer bordered-bar">
    <div className="NodeDetails-progress-inner" style={{ width: `${team?.overall_performance ?? 0}%` }} />
  </div>
</div>

<div className="NodeDetails-metric-cards-container">
  {renderMetricCard("Calories Burned", teamDetails.caloriesburned.value, teamDetails.caloriesburned.performance, teamDetails.caloriesburned.target, selfDetails.caloriesburned.unit, "red", FaFireAlt)}
  {renderMetricCard("Distance", teamDetails.distance.value, teamDetails.distance.performance, teamDetails.distance.target, selfDetails.distance.unit, "green", FaRoad)}
  {renderMetricCard("Steps", teamDetails.steps.value, teamDetails.steps.performance, teamDetails.steps.target, selfDetails.steps.unit, "blue", FaWalking)}
</div>
          </>
        )}
      </div>
    </div>
  );
};

export default NodeDetailsModal;
